import { useSelector } from 'react-redux'
import * as R from 'ramda'

export const usePlaceLogo = () => {
  return useSelector(
    R.path(['auth', 'user', 'data', 'places', '0', 'info', 'logo']),
  )
}
